import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import AdminHeader from "./AdminHeader";
import { Outlet } from "react-router-dom";
export default function AdminLayout() {
    return (_jsxs(_Fragment, { children: [_jsx(AdminHeader, {}), _jsx(Outlet, {})] }));
}
